import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=e94f0edc&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e94f0edc')) {
      api.createRecord('e94f0edc', component.options)
    } else {
      api.reload('e94f0edc', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=e94f0edc&", function () {
      api.rerender('e94f0edc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-270j5iEt9DSqh/JS/pricehelp.vue"
export default component.exports